import { authenticatedFetch } from "@beholos/holoscommon";

interface ComplaintFormData {
  customer: Record<string, string>;
  asset: Record<string, string>;
  reason: Record<string, string>;
}

export const submitComplaint = async (formData: ComplaintFormData): Promise<{ code: string }> => {
  try {
    const response = await authenticatedFetch('/api/auth/complaint', {
      method: 'POST',
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    return data;
  } catch (error: unknown) {
    console.error('Error submitting complaint:', error);
    throw new Error('Se ha producido un error.');
  }
};